import { VideoPlayer as VideoPlayerComponent, type VideoPlayerHandle } from './VideoPlayer';
import { VideoPlayerDraggable } from './Draggable';
import { VideoPlayerStatic } from './Static';
import { VideoPlayerCollapsed } from './Collapsed';
import { PlayerContent } from './PlayerContent';
import { CustomControls } from './CustomControls';
import { VideoPlayerWithActionButton } from './PlayerWithActionButton';

type CompoundedComponent = typeof VideoPlayerComponent & {
	Draggable: typeof VideoPlayerDraggable;
	Static: typeof VideoPlayerStatic;
	Collapsed: typeof VideoPlayerCollapsed;
	Content: typeof PlayerContent;
	Controls: typeof CustomControls;
	WithActionButton: typeof VideoPlayerWithActionButton;
};

const VideoPlayer = VideoPlayerComponent as CompoundedComponent;

VideoPlayer.Draggable = VideoPlayerDraggable;
VideoPlayer.Static = VideoPlayerStatic;
VideoPlayer.Collapsed = VideoPlayerCollapsed;
VideoPlayer.Content = PlayerContent;
VideoPlayer.Controls = CustomControls;
VideoPlayer.WithActionButton = VideoPlayerWithActionButton;

export { VideoPlayer, type VideoPlayerHandle };
